import { render } from "./SideBarNav.vue?vue&type=template&id=2ffd976e"
import script from "./SideBarNav.vue?vue&type=script&lang=js"
export * from "./SideBarNav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__